import { defineComponent as b, ref as u, onBeforeMount as f, openBlock as i, createBlock as h, Teleport as y, createElementVNode as e, normalizeClass as x, withModifiers as l, createElementBlock as a, createCommentVNode as s, createVNode as _, unref as v } from "vue";
import { l as g } from "./chunks/CloseIcon._moEkaop.js";
import "./chunks/DownloadIcon.DHCHRETy.js";
import { _ as C } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseSnackbar.css';const T = { class: "snackbar-container uikit-fixed uikit-bottom-10px uikit-left-10px uikit-z-[2000] max-sm:uikit-left-0 max-sm:uikit-w-full" }, w = ["data-cy"], B = ["src", "alt"], L = {
  key: 1,
  class: "snackbar-type-icon uikit-bg-contain uikit-bg-no-repeat"
}, M = { class: "snackbar-text uikit-px-4 uikit-py-0 uikit-text uikit-font-regular max-sm:uikit-max-w-[80%] max-sm:uikit-pr-0 sm:uikit-text-16" }, S = ["innerHTML"], H = ["innerHTML"], E = /* @__PURE__ */ b({
  inheritAttrs: !1,
  __name: "BaseSnackbar",
  props: {
    type: { default: "" },
    title: {},
    body: {},
    icon: {},
    timeout: { default: 55e4 },
    cb: { default: null }
  },
  emits: ["snackbar-hidden"],
  setup(k, { emit: m }) {
    const n = k, d = m, o = u(null), r = u(null), p = () => {
      o.value && o.value();
    }, c = () => {
      const t = r.value;
      t && (t.classList.remove("snackbar-active"), t.classList.add("snackbar-hidden"), setTimeout(() => {
        d("snackbar-hidden");
      }, 300));
    };
    return f(() => {
      n.cb && (o.value = n.cb), setTimeout(() => {
        c();
      }, n.timeout);
    }), (t, N) => (i(), h(y, { to: "body" }, [
      e("div", T, [
        e("div", {
          ref_key: "snackbar",
          ref: r,
          "data-cy": t.$attrs["data-cy"],
          class: x(["snackbar snackbar-active uikit-flex uikit-items-center uikit-rounded-[5px] uikit-px-4 uikit-py-10px uikit-font-medium uikit-shadow hover:uikit-cursor-pointer max-sm:uikit-relative max-sm:uikit-mx-10px max-sm:uikit-my-0", t.type]),
          onClick: l(p, ["stop"])
        }, [
          t.icon ? (i(), a("img", {
            key: 0,
            src: t.icon.src,
            alt: `${t.icon.alt}`,
            width: "20",
            height: "20"
          }, null, 8, B)) : s("", !0),
          t.type && !t.icon ? (i(), a("span", L)) : s("", !0),
          e("div", M, [
            t.title ? (i(), a("p", {
              key: 0,
              class: "uikit-m-0",
              innerHTML: t.title
            }, null, 8, S)) : s("", !0),
            t.body ? (i(), a("p", {
              key: 1,
              class: "uikit-m-0",
              innerHTML: t.body
            }, null, 8, H)) : s("", !0)
          ]),
          e("button", {
            type: "button",
            "data-cy": "base-snackbar-close-btn",
            class: "uikit-bg-transparent max-sm:uikit-absolute max-sm:uikit-right-5",
            onClick: l(c, ["stop"])
          }, [
            _(v(g), {
              class: "snackbar-close-icon",
              width: 20,
              height: 20,
              "stroke-color": "#000"
            })
          ])
        ], 10, w)
      ])
    ]));
  }
}), I = /* @__PURE__ */ C(E, [["__scopeId", "data-v-ac8cba3f"]]);
export {
  I as default
};
